import { Grid, } from '@mui/material';
import React from 'react';
import DashboardLayout from '../../layout/dashboard/DashboardLayout';
import { useParams } from 'react-router-dom';
import DashboardTabContent from '../../components/project-dashboard/test-case/dashboard/DashboardTabContent';

const ProjectDashboardPage = () => {
  const { projectId } = useParams();

  return (
    <DashboardLayout projectId={projectId}>
      <Grid container spacing={2}>
        <Grid item md={12}>
          <DashboardTabContent />
        </Grid>
      </Grid>
    </DashboardLayout >
  );
};

export default ProjectDashboardPage;
